import React from "react";
import { FieldRow, formatResourceType } from "./FHIRBundleViewer";
import Heading from "../../../../../../components/common-components/zoom/components/heading/Heading";
import { HEADING } from "../../../../../../components/common-components/zoom/components/heading/constants/constants";
import moment from "moment";

export default function FamilyMemberHistory ({resource}){
    const { status,relationship, condition ,sex,date} = resource;
    return(
        <div className="mb-6 p-4 bg-white rounded-lg shadow-md border border-gray-300">
            <Heading type={HEADING.H3}className="text-xl font-bold text-gray-800 mb-4">
                {formatResourceType(resource.resourceType)}
            </Heading>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-2">
                <FieldRow label="Status" value={status} />
                <FieldRow label="Date" value={moment(resource.date).format('L')} />
                <FieldRow label="Relationship" value={relationship?.text} />
                <FieldRow label="Sex" value={sex?.text??sex?.coding[0]?.display??""} />
                <FieldRow label="Condition" value={condition[0]?.code?.text??""}/>
                <FieldRow label="Contributed to death" value={condition[0]?.contributedToDeath?"Yes":"No"} />
                <FieldRow label="Age" value={`${condition[0]?.onsetAge?.value} ${condition[0]?.onsetAge?.unit}`??""}/>
            </div>
           
        </div>
    )
}
